import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import apiService from '../../services/ApiService';

dayjs.extend(customParseFormat);

const ENTRIES_STATE_KEY = 'promotionEntriesState';
const RSD_FORMATTER = new Intl.NumberFormat('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function getPromotionStartDay() {
    const raw = process.env.REACT_APP_PROMOTION_START_DATE;
    if (!raw) return null;

    const parsed = dayjs(raw);
    return parsed.isValid() ? parsed.startOf('day') : null;
}

export const DEFAULT_ENTRY_FILTERS = {
    email: '',
    phone: '',
    pfr: '',
    status: undefined,
    type: undefined,
    dateFrom: null,
    dateTo: null,
};

export function loadEntriesListState() {
    try {
        const saved = localStorage.getItem(ENTRIES_STATE_KEY);
        if (!saved) return null;

        const parsed = JSON.parse(saved);
        return {
            filters: { ...DEFAULT_ENTRY_FILTERS, ...parsed.filters },
            appliedFilters: { ...DEFAULT_ENTRY_FILTERS, ...parsed.appliedFilters },
            pagination: {
                page: parsed.pagination?.page ?? 1,
                limit: parsed.pagination?.limit ?? 50,
            },
        };
    } catch {
        return null;
    }
}

export function saveEntriesListState({ filters, appliedFilters, pagination }) {
    localStorage.setItem(
        ENTRIES_STATE_KEY,
        JSON.stringify({
            filters,
            appliedFilters,
            pagination: { page: pagination.page, limit: pagination.limit },
        })
    );
}

export function clearEntriesListState() {
    localStorage.removeItem(ENTRIES_STATE_KEY);
}

export function formatPfrDateForDisplay(value) {
    if (!value) return '-';

    const parsed = dayjs(value, ['YYYY-MM-DD', 'D.M.YYYY.', 'D.M.YYYY'], true);
    if (!parsed.isValid()) return value;

    return `${parsed.date()}.${parsed.month() + 1}.${parsed.year()}.`;
}

function parseAmountToNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string') return null;

    const raw = value.trim();
    if (!raw) return null;

    const noSpaces = raw.replace(/\s+/g, '');
    const normalized = noSpaces.includes(',')
        ? noSpaces.replace(/\./g, '').replace(',', '.')
        : noSpaces;

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
}

export function formatAmountForDisplay(value) {
    const parsed = parseAmountToNumber(value);
    if (parsed == null) return value || '-';
    return `${RSD_FORMATTER.format(parsed)} RSD`;
}

export async function fetchWinnerEntryMap() {
    const map = new Map();
    let page = 1;
    let totalPages = 1;

    while (page <= totalPages) {
        const [success, error] = await apiService.get(`promotion/winners?page=${page}&limit=100`);

        if (error) break;

        const winners = success?.data?.winners || [];
        totalPages = success?.data?.pagination?.totalPages || 1;

        winners.forEach((winner) => {
            const entryId = winner.entryId || winner.entry?.id;
            if (!entryId) return;

            map.set(entryId, {
                isReserve: winner.isReserve,
                prizeType: winner.prizeType,
                drawRound: winner.drawRound,
            });
        });

        page += 1;
    }

    return map;
}

export function getEntryRowClassName(entryId, winnerEntryMap) {
    const winnerInfo = winnerEntryMap.get(entryId);
    if (!winnerInfo) return '';
    return winnerInfo.isReserve ? 'promotion-reserve-row' : 'promotion-winner-row';
}
